import { makeRequest } from "./api";

export const FetchBathroomTypes = async () => {
  return makeRequest("/api/admin/bathroomType/fetch");
};

export const CreateBathroomType = async (itemName, status) => {
  return makeRequest("/api/admin/bathroomType/create", {
    method: "POST",
    data: {
      itemName,
      status,
    },
  });
};

export const UpdateBathroomType = async (bathroomTypeId, itemName, status) => {
  return makeRequest("/api/admin/bathroomType/update", {
    method: "PUT",
    data: {
      bathroomTypeId,
      itemName,
      status,
    },
  });
};

export const DeleteBathroomType = async (bathroomTypeId) => {
  return makeRequest(`/api/admin/bathroomType/remove/${bathroomTypeId}`, {
    method: "DELETE",
  });
};
